import { PipeDataDto } from 'providers/api';
import { indexBy } from 'ramda';
import PCPipe from './PCPipe';

const toPCPipe = (pipe: PipeDataDto): PCPipe => new PCPipe(
  pipe.name,
  pipe.pipeId,
  pipe.pipeClass,
  pipe.insideDiameter,
  pipe.pressureRating,
  pipe.colour,
  pipe.minimumVelocity,
  pipe.maximumVelocity,
  undefined,
  pipe.minimumPressure,
  pipe.startingThickness,
  pipe.minimumThickness,
);

export default function loadPipes(pipeData: PipeDataDto[]): Record<string, PCPipe> {
  const pipes = pipeData.map(toPCPipe);
  return indexBy((p) => p.pipeId, pipes);
}
